import { map } from 'lodash';
import groupTermsBy from './groupTermsBy';

import { DEFAULT_SPEAKER } from '../constants';
import Term from '../Term';

/**
 *
 * @param source {[Term]} a horizontal list of terms. Assumed to be the output
 *                        of transcriptCompiler.
 * @returns {Term}
 *    a single node with the property speakers, a set
 *    and a value of an array of Terms, each is a group of a single
 *    speaker's words, and their name as a property.
 *    {Term: props {speakers: Set([strings])},
 *                 values: [
 *                   Term: props {speaker: string},
 *                         values: [Term ... Term] (words/punct from original)
 *                 ]
 *   }
 */
export default function bySpeaker(source) {
  const sourceBySpeaker = groupTermsBy(source.value, (term, series, last) => {
    if (term.isMeta) {
      if (term.meta === 'turn') {
        return term.value;
      } if (last) {
        return last.key;
      }
      return DEFAULT_SPEAKER;
    } if (last) {
      return last.key;
    }
    return DEFAULT_SPEAKER;
  });
  /**
   * at this point the series will be in the form
   * [
   *  {
   *    key: speakerName,
   *    terms [
   *        Term (memo node with speaker),
   *        Term (word) ... (term.word);
   *      ]
   *    ]
   *  } ... (key, terms) ...
   * ]
   */

  const speakers = new Set(map(sourceBySpeaker, 'key'));
  const sValue = sourceBySpeaker.map(({ key, terms }) => {
    const value = terms.slice(0);
    if (value[0].isMeta && value[0].meta === 'turn') value.shift();
    return new Term({ props: { type: 'turn', speaker: key }, value });
  });
  return new Term({ value: sValue, type: 'words by speaker', props: { speakers } });
}
